/**
 * Noise Suppression Provider Interface
 *
 * Base class for all noise suppression implementations.
 * Subclasses must implement the abstract methods.
 */

export class NoiseSuppressionProvider {
  constructor(name) {
    this.name = name;
    this.initialized = false;
    this.processing = false;
  }

  /**
   * Get the name of this provider
   * @returns {string}
   */
  getName() {
    return this.name;
  }

  /**
   * Check if this provider is supported on the current device
   * @param {DeviceCapabilities} capabilities
   * @returns {boolean}
   */
  static isSupported(capabilities) {
    throw new Error('isSupported() must be implemented by subclass');
  }

  /**
   * Initialize the noise suppression engine
   * Must be called before process()
   * @returns {Promise<void>}
   */
  async initialize() {
    throw new Error('initialize() must be implemented by subclass');
  }

  /**
   * Process audio samples for noise suppression
   * @param {Float32Array} samples - Input audio samples (normalized -1 to 1)
   * @param {number} sampleRate - Sample rate of the audio
   * @returns {Float32Array} - Processed audio samples
   */
  process(samples, sampleRate) {
    throw new Error('process() must be implemented by subclass');
  }

  /**
   * Check if the provider is ready to process audio
   * @returns {boolean}
   */
  isReady() {
    return this.initialized;
  }

  /**
   * Clean up resources
   * @returns {Promise<void>}
   */
  async destroy() {
    throw new Error('destroy() must be implemented by subclass');
  }
}

export default NoiseSuppressionProvider;
